import React from 'react';
// @ts-ignore
import trim from 'lodash/trim';
var nl2br = function nl2br() {
  var str = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var singleLine = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  if (typeof str !== 'string' || !str.includes('\n')) return str;
  var splittedString = str.split('\n').filter(function (e) {
    return trim(e).length > 0;
  });
  return splittedString.map(function (s, i) {
    return /*#__PURE__*/React.createElement(React.Fragment, {
      key: "line".concat(i)
    }, s, (i < splittedString.length - 1 || singleLine) && /*#__PURE__*/React.createElement("br", null));
  });
};
export default nl2br;